var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 17.2L16.8 13.1C17.2 12.1 17 10.8 16.1 10C15.2 9.1 13.9 8.9 12.8 9.4L14.7 11.3L13.3 12.7L11.3 10.7C10.8 11.8 11 13.1 11.9 14.1C12.8 15 14 15.2 15 14.8L19.1 18.9C19.3 19.1 19.6 19.1 19.7 18.9L20.7 17.9C21 17.6 21 17.3 20.9 17.2ZM11 16H0V14C0 11.8 3.6 10 8 10C8.5 10 9 10 9.4 10.1C9.1 10.7 9 11.3 9 12C9 13.6 9.8 15.1 11 16ZM8 0C5.8 0 4 1.8 4 4C4 6.2 5.8 8 8 8C10.2 8 12 6.2 12 4C12 1.8 10.2 0 8 0Z",
    fill: "#444653"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSettings);
export default __webpack_public_path__ + "static/media/userSettings.59913b2f8a054f10fde071d6efa05d8e.svg";
export { ForwardRef as ReactComponent };